import React from "react";

/** Ambient dark nebula background with slowly drifting glow orbs. */
export function AmbientBackground() {
  return (
    <div className="pointer-events-none fixed inset-0 -z-10 overflow-hidden" aria-hidden="true">
      <div className="absolute inset-0 bg-[#05070D]" />
      {/* Subtle noise */}
      <div
        className="absolute inset-0 opacity-[0.035] mix-blend-overlay"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2' stitchTiles='stitch'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.6'/></svg>\")",
        }}
      />
      {/* Blue orb */}
      <div
        className="absolute -top-40 -left-40 w-[520px] h-[520px] rounded-full opacity-40 animate-orb-drift"
        style={{ background: "radial-gradient(closest-side, #2563EB, transparent)", filter: "blur(120px)" }}
      />
      {/* Indigo orb */}
      <div
        className="absolute top-1/3 -right-40 w-[560px] h-[560px] rounded-full opacity-35 animate-orb-drift-2"
        style={{ background: "radial-gradient(closest-side, #4F46E5, transparent)", filter: "blur(140px)" }}
      />
      {/* Cyan orb */}
      <div
        className="absolute -bottom-40 left-1/3 w-[520px] h-[520px] rounded-full opacity-25 animate-orb-drift"
        style={{ background: "radial-gradient(closest-side, #06B6D4, transparent)", filter: "blur(140px)" }}
      />
    </div>
  );
}
